module.exports = __webpack_public_path__ + "img/fa-chart-bar.52c7bb92.png";